const reducer = (state = { showMenu: false }, action) => {
  switch (action.type) {
    case "SHOW_MENU":
      return { ...state, showMenu: action.payload };
      break;

    default:
      return state;
      break;
  }
};

export default reducer;
